import { Attribute } from '~/definitions/attribute';

export const getAttributeValueByNumber = (number: string, attributes: Attribute[]): string => {
    const attribute = attributes?.filter((attr) => attr.number === number);
    const value = attribute?.[0]?.values?.[0] || '';
    return value;
};
